import type { InjectionKey } from "vue"

export interface EnrollmentFooterControl {
  setIsComparingPlans: (value: boolean) => void
}

export const enrollmentFooterControlKey: InjectionKey<EnrollmentFooterControl> = Symbol("enrollmentFooterControl")
